import { TableData, TableRow } from '@Components/Table';
import { EmailLogTable } from '@Models/report.model';

const messageCharsLimit = 170;

export const trimMessage = (
  message: string
): { trimmedMessage: string; wasTrimmed: boolean } => {
  const brIndex = message.indexOf('<br>');
  let trimmedMessage = message;
  let wasTrimmed = false;

  // if there are <br> - trim up to this tag; else - return first 170 chars
  if (brIndex !== -1 && brIndex <= messageCharsLimit) {
    trimmedMessage = `${message.substring(0, brIndex)}...`;
    wasTrimmed = true;
  } else if (message.length > messageCharsLimit) {
    trimmedMessage = `${message.substring(0, messageCharsLimit)}...`;
    wasTrimmed = true;
  }

  return { trimmedMessage, wasTrimmed };
};

/** Returns data for table row in desired format. */
export const createData = (
  sentAt: string,
  emailTo: string,
  message: string,
  actions?: React.ReactNode
): TableData => ({
  dateStart: sentAt,
  emailTo,
  // display text as formatted html
  // eslint-disable-next-line react/no-danger
  message: <div dangerouslySetInnerHTML={{ __html: message }} />,
  actions,
});

/** Returns Rows for Collapsible Table (Email Log) */
export const GetRows = (
  table: EmailLogTable[],
  actions: (id: string) => JSX.Element,
  open: { [key: string]: boolean }
): TableRow[] =>
  table.map((data) => {
    const { trimmedMessage, wasTrimmed } = trimMessage(data.message);

    return {
      id: data.id,
      data: createData(
        data.sentAt,
        data.emailTo,
        open[data.id] ? data.message : trimmedMessage,
        wasTrimmed ? actions(`${data.id}`) : undefined
      ),
    };
  });
